import { poGetExclusivityYears } from '@repo/sdk/gen'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/lib/query-keys'

export function poExclusivityYearsQueryOptions() {
	return queryOptions({
		queryKey: makeQueryKeys.po.exclusivityYears(),
		queryFn: ({ signal }) => poGetExclusivityYears({ signal })
	})
}
